import { render } from "./ScaleVM.vue?vue&type=template&id=3bf16c94&scoped=true"
import script from "./ScaleVM.vue?vue&type=script&lang=js"
export * from "./ScaleVM.vue?vue&type=script&lang=js"

import "./ScaleVM.vue?vue&type=style&index=0&id=3bf16c94&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.21.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf16c94"]])

export default __exports__